// extracted by mini-css-extract-plugin
export default {"panelBox_wrapper":"panelitem_panelBox_wrapper__eSXQa"};